
export const global = [
  {
    type: 'color',
    defaultValue: '#ffffff',
    value: 'backgroundColor',
    label: 'Background color'
  }
]